import { useNativeDonationManagement, usePlatformService } from 'core';
import { ClickableOptionsCard } from 'core/Components';
import { notifications } from 'ui';

import {
  DonationSettingModalProvider,
  useDonationSettingModalProvider,
} from './DonationSettingsModalProvider';
import { CancelDonationModal } from './modals/CancelDonationModal';
import { EditCashbackAllocationModal } from './modals/EditCashbackAllocationModal';
import { EditRecurringDonationModal } from './modals/EditRecurringDonationModal';
import { ManageRecurringDonationsModal } from './modals/ManageRecurringDonationsModal';
import { UpdatePaymentMethodModal } from './modals/UpdatePaymentMethodModal';

const DonationSettingsAction = () => {
  const platform = usePlatformService();
  const { openModalById } = useDonationSettingModalProvider({});

  const { openNativeDonation } = useNativeDonationManagement({
    type: 'manage_donations',
    onSuccess() {
      notifications.show({
        variant: 'success',
        message: 'Checkout successful!',
      });
    },
  });

  const handleOpen = () => {
    if (platform.isNative) {
      void openNativeDonation({ routeParams: undefined });
    } else {
      openModalById('ManageRecurring');
    }
  };
  return (
    <>
      <ClickableOptionsCard.Row title="Manage Recurring Donations" onClick={handleOpen} />
      <ClickableOptionsCard.Row
        title="Edit Cashback Allocation"
        onClick={() => openModalById('EditAllocation')}
      />
    </>
  );
};

const DonationSettingsModalGroup = () => {
  return (
    <DonationSettingModalProvider meta={{}}>
      <DonationSettingsAction />
      <ManageRecurringDonationsModal />
      <EditRecurringDonationModal />
      <EditCashbackAllocationModal />
      <UpdatePaymentMethodModal />
      <CancelDonationModal />
    </DonationSettingModalProvider>
  );
};

export { DonationSettingsModalGroup };
